import { gql, useQuery } from "@apollo/client";
import {
  UseCaseManagementOverview,
  UseCaseManagementOverviewVariables
} from "./schema/UseCaseManagementOverview";

export const queryUseCaseManagementList = gql`
  query UseCaseManagementOverview($solutionKey: Key!) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        useCases {
          useCases(latestVersionOnly: false) {
            detail {
              key
              name
              version
              description
              tags
              transactionTable
            }
          }
        }
      }
    }
  }
`;

export const useUseCaseManagementOverview = (solutionKey: string) =>
  useQuery<UseCaseManagementOverview, UseCaseManagementOverviewVariables>(
    queryUseCaseManagementList,
    { variables: { solutionKey } }
  );
